/**
 *  Bug #473 
 * @Author Anupama P 
 * @Date 13 Jul 2021 
 * */
import { PageNotFoundPath } from 'config/routersConstants'
import { Loader } from 'components'
import { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { PrivateRoute } from 'shared/auth/private-route'
import PublicRoute from 'shared/auth/public-route'
import { NormalRouting } from './NormalRouting'
import { PrivateRouting } from './PrivateRouting'
import { PublicRouting } from './PublicRouting'
import { Usertype } from 'config/UserTypes';/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */

export default function ClientRouter() {



    return (
        // <ClientRouterComponent>
        <Suspense fallback={
            <Loader />
        }>

            <Switch>
                {PublicRouting.map((props, index) =>
                    <PublicRoute path={props.path} component={props.component} exact key={index} />
                )}
                {PrivateRouting.map((props, index) =>
                    <PrivateRoute path={props.path} component={props.component} exact key={index} {...props} />/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
                )}
                {NormalRouting.map((props, index) =>
                    <Route path={props.path} component={props.component} exact key={index} />
                )}
                {/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
                Usertype.map((userType, index)=>
                
                userType.type >= 0 && 
                <PrivateRoute exact path={userType.user} key={index}>
                    <Redirect to={userType.dashboard} />
                </PrivateRoute>
                )}

                <Redirect to={PageNotFoundPath.path} />
            </Switch>
        </Suspense>
        // </ClientRouterComponent>

    )
}
/** End */